import * as React from 'react';

import {Component, deps, inject, observer} from '../lib/component';
import ConnectedChannelReferral from '../components/channel/referral';

type Props = {};

@inject(deps) @observer
export class ChannelReferralPage extends Component<Props> {
  render() {
    const {channel} = this.props.model.page.channelReferral;

    if (!channel)
      return null;

    return (
      <ConnectedChannelReferral channel={channel}/>
    )
  }
}